var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"grid-list-md":"","pa-0":"","relative":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[(_vm.$auth.getRole()==='super')?_c('super-dashboard'):(_vm.$auth.getRole()==='guardian')?_c('guardian-dashboard'):_c('dashboard')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }